import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MetaService } from '../../../services/meta.service';

@Component({
  selector: 'app-ai-assisted-integrations',
  templateUrl: './ai-assisted-integrations.component.html',
  styleUrls: ['./ai-assisted-integrations.component.scss']
})
export class AiAssistedIntegrationsComponent implements OnInit {
  imageUrl!: string;
  contentTitle = 'AI Assisted Integrations - Xipe Tech';
  contentDescription = 'Empower your business with XipeTech’s AI Assisted Integrations. We streamline workflows, enhance decision-making, and connect your systems seamlessly using cutting-edge artificial intelligence solutions.';
  contentKeywords = 'AI Assisted Integrations, AI integration services, AI workflow automation, artificial intelligence solutions, AI-powered business tools, system integration with AI, AI automation services, AI business optimization, intelligent integrations, AI-driven process improvement';
  pageUrl!: string;
  siteTitle = 'Revolutionary IT Solutions – XipeTech';
  ext = 'png';

  constructor(private metaService: MetaService, private router: Router) { }

  ngOnInit(): void {
    const baseUrl = window.location.origin;
    // Set the page title
    this.metaService.setMetaData({
      title: this.contentTitle,
      description: this.contentDescription,
      keywords: this.contentKeywords,
      siteTitle: this.siteTitle,
      pageUrl: `${baseUrl}${this.router.url}`,
      imageUrl: `${baseUrl}/assets/img/xipetech.png`,
      ext: this.ext
    });
  }
}
